import {
    AfterViewInit,
    Directive,
    ElementRef,
    inject,
    Renderer2,
} from '@angular/core';
import { ProfileProvider } from '@pf/shared-common';
import { combineLatest, take } from 'rxjs';

const AdministratorGroupType = 'administrator';
const FirebendEmailDomain = '@firebend.com';

@Directive({
    selector: '[pfFirebendAdmin]',
    standalone: false,
})
export class FirebendAdminDirective implements AfterViewInit {
    private profileProvider = inject(ProfileProvider);
    private elRef = inject(ElementRef);
    private renderer = inject(Renderer2);

    ngAfterViewInit(): void {
        this.checkGroupType();
    }

    private checkGroupType() {
        combineLatest([
            this.profileProvider.userGroupType$,
            this.profileProvider.email$,
        ])
            .pipe(take(1))
            .subscribe(([userGroupType, email]) => {
                if (
                    userGroupType.toLowerCase() === AdministratorGroupType &&
                    email.endsWith(FirebendEmailDomain)
                ) {
                    this.elRef.nativeElement.classList.add('pf-firebend-admin');
                    return;
                }
                this.renderer.removeChild(
                    this.elRef.nativeElement.parentNode,
                    this.elRef.nativeElement
                );
            });
    }
}
